import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger, SheetClose } from './ui/sheet';
import { useEventDialog } from '../context/EventDialogContext';

const Header = () => {
  const location = useLocation();
  const { openInspiration, openRSVP } = useEventDialog();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-orange-600/30">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            data-testid="header-logo"
            className="text-2xl mad-max-title hover:scale-105 transition-transform"
          >
            FURY ROSE
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              data-testid="nav-home"
              className={`font-bold text-lg transition-all duration-300 hover:text-orange-400 ${
                isActive('/') ? 'text-orange-400 border-b-2 border-orange-400' : 'text-gray-300'
              }`}
            >
              Accueil
            </Link>
            <button
              onClick={openInspiration}
              data-testid="nav-inspiration"
              className="font-bold text-lg transition-all duration-300 hover:text-orange-400 text-gray-300"
            >
              Inspiration
            </button>
            <button
              onClick={openRSVP}
              data-testid="nav-rsvp"
              className="font-bold text-lg transition-all duration-300 hover:text-orange-400 text-gray-300"
            >
              RSVP
            </button>
            <Link
              to="/contact"
              data-testid="nav-contact"
              className={`font-bold text-lg transition-all duration-300 hover:text-orange-400 ${
                isActive('/contact') ? 'text-orange-400 border-b-2 border-orange-400' : 'text-gray-300'
              }`}
            >
              Contact et Lieu
            </Link>
            <Link
              to="/photos"
              data-testid="nav-photos"
              className={`font-bold text-lg transition-all duration-300 hover:text-orange-400 ${
                isActive('/photos') ? 'text-orange-400 border-b-2 border-orange-400' : 'text-gray-300'
              }`}
            >
              Photos
            </Link>
            <Link
              to="/remerciement"
              data-testid="nav-remerciement"
              className={`font-bold text-lg transition-all duration-300 hover:text-orange-400 ${
                isActive('/remerciement') ? 'text-orange-400 border-b-2 border-orange-400' : 'text-gray-300'
              }`}
            >
              Remerciement
            </Link>
          </nav>

          {/* Mobile Navigation */}
          <Sheet>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon" data-testid="mobile-menu-btn" className="text-orange-400 hover:text-orange-300">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-neutral-900 border-orange-600/30">
              <nav className="flex flex-col gap-6 mt-8">
                <SheetClose asChild>
                  <Link
                    to="/"
                    data-testid="mobile-nav-home"
                    className={`font-bold text-xl transition-colors ${
                      isActive('/') ? 'text-orange-400' : 'text-gray-300 hover:text-orange-400'
                    }`}
                  >
                    Accueil
                  </Link>
                </SheetClose>
                <SheetClose asChild>
                  <button
                    onClick={openInspiration}
                    data-testid="mobile-nav-inspiration"
                    className="font-bold text-xl text-left text-gray-300 hover:text-orange-400 transition-colors"
                  >
                    Inspiration
                  </button>
                </SheetClose>
                <SheetClose asChild>
                  <button
                    onClick={openRSVP}
                    data-testid="mobile-nav-rsvp"
                    className="font-bold text-xl text-left text-gray-300 hover:text-orange-400 transition-colors"
                  >
                    RSVP
                  </button>
                </SheetClose>
                <SheetClose asChild>
                  <Link
                    to="/contact"
                    data-testid="mobile-nav-contact"
                    className={`font-bold text-xl transition-colors ${
                      isActive('/contact') ? 'text-orange-400' : 'text-gray-300 hover:text-orange-400'
                    }`}
                  >
                    Contact et Lieu
                  </Link>
                </SheetClose>
                <SheetClose asChild>
                  <Link
                    to="/photos"
                    data-testid="mobile-nav-photos"
                    className={`font-bold text-xl transition-colors ${
                      isActive('/photos') ? 'text-orange-400' : 'text-gray-300 hover:text-orange-400'
                    }`}
                  >
                    Photos
                  </Link>
                </SheetClose>
                <SheetClose asChild>
                  <Link
                    to="/remerciement"
                    data-testid="mobile-nav-remerciement"
                    className={`font-bold text-xl transition-colors ${
                      isActive('/remerciement') ? 'text-orange-400' : 'text-gray-300 hover:text-orange-400'
                    }`}
                  >
                    Remerciement
                  </Link>
                </SheetClose>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
